import {
  FundOutlined,
  GlobalOutlined,
  MobileOutlined,
  QrcodeOutlined,
  ScheduleOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

const { Title } = Typography;

const Panel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 48px;
  color: #fff;
  background-image: linear-gradient(160deg, #ffb81c 0%, #ee7700 100%);
`;

const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  padding: 48px 0;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const Card = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 8px;

  .anticon {
    font-size: 22px;
  }
`;

const features = () => [
  { icon: <GlobalOutlined />, label: t`Event Website and Registration` },
  { icon: <MobileOutlined />, label: t`Event App` },
  { icon: <QrcodeOutlined />, label: t`Check-in and Badge Printing` },
  { icon: <TeamOutlined />, label: t`Networking and Community` },
  { icon: <ScheduleOutlined />, label: t`Exhibitor Lead Capture` },
  { icon: <FundOutlined />, label: t`Analytics and Reporting` },
];

const MarketingPanel = () => (
  <Panel>
    <Body>
      <Title
        style={{ color: '#fff', margin: 0 }}
      >{t`Event Management Software That's Easy to Use. Easy to Love.`}</Title>
      <Title
        style={{ color: '#fff', margin: 0 }}
        level={4}
      >{t`Where all your event management tools connect in one place`}</Title>
      <CardGrid>
        {features().map(({ icon, label }) => (
          <Card key={label}>
            {icon}
            <span>{label}</span>
          </Card>
        ))}
      </CardGrid>
    </Body>
  </Panel>
);

export default MarketingPanel;
